import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalTypesComponent } from 'app/components/shared/modals-types/modal-types.component';
import { Checkpoint } from 'app/models2/localization/checkpoint';
import { MapRoute, Marker } from 'app/models2/localization/map-route';
import { TravelHistory } from 'app/models2/localization/travel-history';
import { TravelRoute } from 'app/models2/localization/travel-route';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { HttpService, MessageService } from 'brainloper-ui';

@Component({
  selector: 'app-travel-history-summary',
  templateUrl: './travel-history-summary.component.html',
  styleUrls: ['./travel-history-summary.component.scss'],
})
export class TravelHistorySummaryComponent implements OnInit {
  @Input() travelHistoryId: number;

  travelHistory: TravelHistory = null;
  originalRoute: TravelRoute = null;
  private EndpointDictionary = EndpointDictionary;
  markers: Marker[] = [];
  colorComplete: string = '#36858a94';
  colorIncomplete: string = '#d18888';

  constructor(
    private http: HttpService,
    private message: MessageService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {}

  async ngOnChanges(changes: SimpleChanges) {
    await this.getDataSumary();
    this.convertCheckpointsToMarkers();
  }

  async getDataSumary() {
    this.message.openLoading('Cargando', 'Cargando información');
    let travelRoute = await this.http.getDataBody<TravelHistory>(
      `${this.EndpointDictionary.Travelhistory.CRUD_TRAVEL_HISTORY}/${this.travelHistoryId}`
    );
    
    if (travelRoute && travelRoute.id) {

      this.originalRoute = await this.http.getDataBody<TravelHistory>(
        `${this.EndpointDictionary.TravelRoute.CRUD_TRAVEL_ROUTER}/${travelRoute.routeId}`
      );

      this.travelHistory = travelRoute;
      this.travelHistory.checkpoints.forEach((checkpoint) => {
        checkpoint.buttonsType = [4];
        if (checkpoint.latitude === null || checkpoint.longitude === null) {
          checkpoint.background = this.colorIncomplete;
          delete checkpoint.date;
        }
      });;   

      const travelDetails = this.calculateTimeForTravel(this.travelHistory.checkpoints);
      this.travelHistory.timeHours = travelDetails.time;

      
      // this.isSameRoute = this.compareRoutes(
      //   this.originalRoute[0].checkpoints,
      //   travelRoute.checkpoints
      // );
    }

    this.message.closeLoading();
  }

  getRouterData($event: MapRoute) {
    const distanceInt: number = Math.round(parseFloat($event.travelDistance));   
    this.travelHistory.distance = distanceInt;   
  }
  
  calculateTimeForTravel(checkpoints: Checkpoint[]): { time: number } {
    let totalTime = 0;

    const validCheckpoints = checkpoints.filter(checkpoint => checkpoint.latitude !== null && checkpoint.longitude !== null);
  
    if (validCheckpoints.length > 1) {        
      const start = validCheckpoints[0];
      const end = validCheckpoints[validCheckpoints.length - 1];  
      if (start.date && end.date) {
        const startDate = new Date(start.date);
        const endDate = new Date(end.date);
        totalTime = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60); // Convert milliseconds to hours
      }
    }
  
    return {
      time: Math.round(totalTime) // Time in hours, rounded to nearest integer
    };
  }

  convertCheckpointsToMarkers() {
    this.markers = this.travelHistory.checkpoints
      .filter(
        (checkpoint) =>
          checkpoint.latitude !== null && checkpoint.longitude !== null
      )
      .map((checkpoint, index) => {
        let markerOrder: string;

        if (index === 0) {
          markerOrder = 'Punto Origen';
        } else if (index === this.travelHistory.checkpoints.length - 1) {
          markerOrder = 'Punto Destino';
        } else {
          markerOrder = `Punto de Control ${index}`;
        }

        return {
          position: { lat: checkpoint.latitude, lng: checkpoint.longitude },
          option: { draggable: true },
          order: markerOrder,
          id: checkpoint.name,
        };
      });
  }

  async openAddCheckpointDialog($event?: Checkpoint) {
    let size: number = screen.width > 500 ? 60 : 50;
    $event.complete = true;
    const dialogRef = this.dialog.open(ModalTypesComponent, {
      width: `${size}vh`,
      data: {
        name: 'punto de control',
        body: $event,
      },
    });
  }

  // compareRoutes(
  //   originalRoute: Checkpoint[],
  //   travelRoute: Checkpoint[]
  // ): boolean {
  //   if (originalRoute.length !== travelRoute.length) {
  //     return false;
  //   }
  
  //   for (const [index, originalCheckpoint] of originalRoute.entries()) {
  //     const travelCheckpoint = travelRoute[index];
  //     if (
  //       originalCheckpoint.name !== travelCheckpoint.name ||
  //       originalCheckpoint.complete !== travelCheckpoint.complete
  //     ) {
  //       return false;
  //     }
  //   }
  
  //   return true;
  // }
}
